export default __webpack_public_path__ + "92dc2f0d8ff67913ebd1ff02064b2f96.png";